import { createContext } from 'react';

export interface BindContext {
  submitBind(nonce: string): Promise<void>;
}

export const BindContext = createContext<BindContext>({
  submitBind: () => Promise.resolve(),
});
